<script setup lang="ts">
const { baseHeaderBottom: headerHeight } = useBaseHeaderBounding(
  "base-header-container",
);
const filterSidebar = useTemplateRef("filter-sidebar");
const { top: filterSidebarHeight } = useElementBounding(filterSidebar);
const debouncedFilterSidebarHeight = refDebounced(filterSidebarHeight, 20);

const sidebarHeight = computed(() => {
  const positiveHeight = Math.max(0, debouncedFilterSidebarHeight.value);

  return `calc(100vh - ${positiveHeight}px)`;
});
</script>

<template>
  <aside class="hidden md:block w-80 flex-shrink-0">
    <div
      id="filter-sidebar"
      ref="filter-sidebar"
      class="hidden md:block sticky overflow-y-auto overflow-x-hidden -ml-4 slider"
      :style="{
        top: `${headerHeight}px`,
        height: sidebarHeight,
      }"
      data-test="sticky-sidebar"
    >
      <slot />
    </div>
  </aside>
</template>

<style scoped lang="postcss">
.slider {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
